// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3E%3Cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlight,
.highlight * {
  background: #e6edec !important;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

.text-muted-light {
  color: #ababab !important;
}

.lm_tab {
  height: 31px !important;
  line-height: 31px;
}

.lm_close_tab {
  height: 26px !important;
}

.lm_controls {
  top: 4px;
}

.lm_title {
  font-weight: bold;
  font-size: larger;
}

a.nav-link {
  font-size: initial;
  font-weight: 800;
  color: white;
}

.container-element {
  padding-top: 46.5px;
}

.dropDownButton {
  color: black !important;
  font-weight: 400 !important;
  text-align: center !important;
  padding: 0 !important;
}

.MuiTablePagination-displayedRows {
  margin: 0;
}
.MuiTablePagination-selectLabel {
  margin: 0;
}

.css-nfmglb-MuiTableCell-root {
  padding-right: 1px !important;
  padding-left: 1px !important;
}

.MuiIconButton-root {
  padding: 0px !important;
  height: 20px;
  margin: 0px !important;
}

.MuiTableCell-footer {
  height: 40px;
}

.MuiToolbar-gutters {
  min-height: 39px !important;
}

.highlightClass {
  background-color: transparent;
  font-weight: bold;
}

.highlighterContainer {
  display: block;
  margin-bottom: 10px;
}


.highlightSemantic {
  background-color: #17a2b8;
}

.highlightSemanticClicked {
  background-color: #b0e0e6;
}

.popup-container {
  margin-top: 100px;
  margin-bottom: 120px;
}

.textFieldComp > div > input {
  padding: 0px;
  padding-left: 4px;
}

.container-item {
  text-align: left;
  display: inline-block;
}
.chips-container {
  text-align: center;
  display: inline-block;
  width: 100%;
}

.center {
  text-align: center;
  display: inline-block;
  width: 100%;
}

.dropDownOptions > div > div {
  padding-top: 4px;
  padding-bottom: 4px;
}

.associated {
  color: red;
}

span.associated:hover {
  color: rgb(145, 44, 44);
}

.droppable-box {
  height: 20px;
}

.droppable-box-mini {
  width: 300px;
  height: 10px;
}

.dragging {
  border-bottom: 2px solid rgb(92, 91, 91);
}

div.droppable-box-mini-hover:hover {
  color: #61dafb;
  background-color: aquamarine;
}

.typeaheadSelected > div > input {
  font-weight: bolder;
}

.MuiTableCell-paddingCheckbox {
  background-color: #e6edec !important;
}

.export_tabs .nav-link.active {
  font-weight: 800;
}
.export_tabs .nav-link {
  color: #5a5a5a;
  font-weight: 400;
}

.list_terms {
  max-height: 200px;
  overflow-y: auto;
}

.MuiPaper-root > .MuiPaper-root {
  justify-content: flex-end;
    flex-direction: row-reverse;
    padding-left: 10px;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50%/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: .5;
}

.c-pointer {
  cursor: pointer;
}

.c-not-allowed {
  cursor:not-allowed;
}


.term_badge {
  border-radius: 0.4rem;
  background: rgb(204, 204, 204);
  width: fit-content;
}

.modal-header > button {
  margin-left: auto;
}

.modal-header > button {
  margin-left: auto;
}

.w-90 {
  width: 65% !important;
  max-width: 65% !important;
  margin-top: 10% !important;
}

.semantic_tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: auto;
}
.semantic_tab > .semantic_tab__tree__root {
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.semantic_tab .MuiTablePagination-root {
  overflow: initial;
  width: fit-content;
}
.semantic_tab > .semantic_tab__tree__root > .semantic_tab__tree_items {
  overflow-y: auto;
}

.tab-w-1 {
  width: 15px;
}

.tab-m-1 {
  margin-right: 15px;
  margin-left: 15px;
}

.tab-m-2 {
  margin-right: 30px;
  margin-left: 30px;
}

.tab-m-3 {
  margin-right: 45px;
  margin-left: 45px;
}

.tab-mr-1 {
  margin-right: 15px;
}

.tab-mr-2 {
  margin-right: 30px;
}

.tab-mr-3 {
  margin-right: 45px;
}

.tab-ml-1 {
  margin-left: 15px;
}

.tab-ml-2 {
  margin-left: 30px;
}

.tab-ml-3 {
  margin-left: 45px;
}

.opacity-50 {
  opacity: 0.5;
}

.f-s-15 {
  font-size: 15px !important;
}

.f-s-14 {
  font-size: 14px !important;
}

.f-s-13 {
  font-size: 13px !important;
}

.f-w-1 {
  font-weight: 600;
}

.tab-relation {
  width: 15px;
  margin-right: 15px;
  margin-left: 15px;
  font-size: 15px !important;
}

.draggable-item {
  position: absolute;
  right: -10px;
  bottom: 0;
  background-color: #ffce67;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action_btns {
  position: absolute;
  top: 8px;
  right: 10px;
  display: flex;
  align-items: center;
}

.split_btn, 
.pin_btn {
  border: none;
  outline: none !important;
  padding: 0;
  background: none;
  display: flex;
  align-items: center;
}

.mw-50 {
  max-width: 50%;
}

.count_badge {
  background-color: #6c757d !important;
}

.MuiTableRow-root.MuiTableRow-head {
  vertical-align: bottom;
}

.min-width-50 {
  min-width: 50px;
}

.rbt-menu > .dropdown-item {
  display: flex;
    flex-direction: column;
}

.link_text {
  color: #78C2AD;
  cursor: pointer;
}

.link_text:hover {
  text-decoration: underline;
}

.alert-custom {
  button {
    position: absolute;
    top: 0.6em;
    right: 0.6em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;IACvB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,eAAe;EACf,WAAW;EACX,sFAA8X;EAC9X,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;IACX,sBAAsB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".highlight,\n.highlight * {\n  background: #e6edec !important;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\n.text-muted-light {\n  color: #ababab !important;\n}\n\n.lm_tab {\n  height: 31px !important;\n  line-height: 31px;\n}\n\n.lm_close_tab {\n  height: 26px !important;\n}\n\n.lm_controls {\n  top: 4px;\n}\n\n.lm_title {\n  font-weight: bold;\n  font-size: larger;\n}\n\na.nav-link {\n  font-size: initial;\n  font-weight: 800;\n  color: white;\n}\n\n.container-element {\n  padding-top: 46.5px;\n}\n\n.dropDownButton {\n  color: black !important;\n  font-weight: 400 !important;\n  text-align: center !important;\n  padding: 0 !important;\n}\n\n.MuiTablePagination-displayedRows {\n  margin: 0;\n}\n.MuiTablePagination-selectLabel {\n  margin: 0;\n}\n\n.css-nfmglb-MuiTableCell-root {\n  padding-right: 1px !important;\n  padding-left: 1px !important;\n}\n\n.MuiIconButton-root {\n  padding: 0px !important;\n  height: 20px;\n  margin: 0px !important;\n}\n\n.MuiTableCell-footer {\n  height: 40px;\n}\n\n.MuiToolbar-gutters {\n  min-height: 39px !important;\n}\n\n.highlightClass {\n  background-color: transparent;\n  font-weight: bold;\n}\n\n.highlighterContainer {\n  display: block;\n  margin-bottom: 10px;\n}\n\n\n.highlightSemantic {\n  background-color: #17a2b8;\n}\n\n.highlightSemanticClicked {\n  background-color: #b0e0e6;\n}\n\n.popup-container {\n  margin-top: 100px;\n  margin-bottom: 120px;\n}\n\n.textFieldComp > div > input {\n  padding: 0px;\n  padding-left: 4px;\n}\n\n.container-item {\n  text-align: left;\n  display: inline-block;\n}\n.chips-container {\n  text-align: center;\n  display: inline-block;\n  width: 100%;\n}\n\n.center {\n  text-align: center;\n  display: inline-block;\n  width: 100%;\n}\n\n.dropDownOptions > div > div {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.associated {\n  color: red;\n}\n\nspan.associated:hover {\n  color: rgb(145, 44, 44);\n}\n\n.droppable-box {\n  height: 20px;\n}\n\n.droppable-box-mini {\n  width: 300px;\n  height: 10px;\n}\n\n.dragging {\n  border-bottom: 2px solid rgb(92, 91, 91);\n}\n\ndiv.droppable-box-mini-hover:hover {\n  color: #61dafb;\n  background-color: aquamarine;\n}\n\n.typeaheadSelected > div > input {\n  font-weight: bolder;\n}\n\n.MuiTableCell-paddingCheckbox {\n  background-color: #e6edec !important;\n}\n\n.export_tabs .nav-link.active {\n  font-weight: 800;\n}\n.export_tabs .nav-link {\n  color: #5a5a5a;\n  font-weight: 400;\n}\n\n.list_terms {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.MuiPaper-root > .MuiPaper-root {\n  justify-content: flex-end;\n    flex-direction: row-reverse;\n    padding-left: 10px;\n}\n\n.btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3E%3Cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3E%3C/svg%3E\") 50%/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: .5;\n}\n\n.c-pointer {\n  cursor: pointer;\n}\n\n.c-not-allowed {\n  cursor:not-allowed;\n}\n\n\n.term_badge {\n  border-radius: 0.4rem;\n  background: rgb(204, 204, 204);\n  width: fit-content;\n}\n\n.modal-header > button {\n  margin-left: auto;\n}\n\n.modal-header > button {\n  margin-left: auto;\n}\n\n.w-90 {\n  width: 65% !important;\n  max-width: 65% !important;\n  margin-top: 10% !important;\n}\n\n.semantic_tab {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-x: auto;\n}\n.semantic_tab > .semantic_tab__tree__root {\n  flex-grow: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n.semantic_tab .MuiTablePagination-root {\n  overflow: initial;\n  width: fit-content;\n}\n.semantic_tab > .semantic_tab__tree__root > .semantic_tab__tree_items {\n  overflow-y: auto;\n}\n\n.tab-w-1 {\n  width: 15px;\n}\n\n.tab-m-1 {\n  margin-right: 15px;\n  margin-left: 15px;\n}\n\n.tab-m-2 {\n  margin-right: 30px;\n  margin-left: 30px;\n}\n\n.tab-m-3 {\n  margin-right: 45px;\n  margin-left: 45px;\n}\n\n.tab-mr-1 {\n  margin-right: 15px;\n}\n\n.tab-mr-2 {\n  margin-right: 30px;\n}\n\n.tab-mr-3 {\n  margin-right: 45px;\n}\n\n.tab-ml-1 {\n  margin-left: 15px;\n}\n\n.tab-ml-2 {\n  margin-left: 30px;\n}\n\n.tab-ml-3 {\n  margin-left: 45px;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.f-s-15 {\n  font-size: 15px !important;\n}\n\n.f-s-14 {\n  font-size: 14px !important;\n}\n\n.f-s-13 {\n  font-size: 13px !important;\n}\n\n.f-w-1 {\n  font-weight: 600;\n}\n\n.tab-relation {\n  width: 15px;\n  margin-right: 15px;\n  margin-left: 15px;\n  font-size: 15px !important;\n}\n\n.draggable-item {\n  position: absolute;\n  right: -10px;\n  bottom: 0;\n  background-color: #ffce67;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action_btns {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.split_btn, \n.pin_btn {\n  border: none;\n  outline: none !important;\n  padding: 0;\n  background: none;\n  display: flex;\n  align-items: center;\n}\n\n.mw-50 {\n  max-width: 50%;\n}\n\n.count_badge {\n  background-color: #6c757d !important;\n}\n\n.MuiTableRow-root.MuiTableRow-head {\n  vertical-align: bottom;\n}\n\n.min-width-50 {\n  min-width: 50px;\n}\n\n.rbt-menu > .dropdown-item {\n  display: flex;\n    flex-direction: column;\n}\n\n.link_text {\n  color: #78C2AD;\n  cursor: pointer;\n}\n\n.link_text:hover {\n  text-decoration: underline;\n}\n\n.alert-custom {\n  button {\n    position: absolute;\n    top: 0.6em;\n    right: 0.6em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
